/** @jsxImportSource @emotion/react */
import {
  BorderStyle,
  Box,
  Color,
  Heading6,
  Join,
} from '@gousto-internal/citrus-react'
import { zendeskAPI } from 'src/config/routes'
import { useFetch } from 'src/hooks/useFetch'
import { BackendCategory } from 'src/types/entities'
import { createSlugFromUrl, mapBackendCategories } from 'src/utils'
import { OtherTopic } from './OtherTopic'

interface CategoriesResponse {
  categories: BackendCategory[]
}

const OtherHelpTopics = () => {
  const { fetchResponse, fetchError } = useFetch<CategoriesResponse>({ url: zendeskAPI.categories })
  const backendCategories = fetchResponse?.categories

  const categories = backendCategories && mapBackendCategories(backendCategories)

  if (!categories?.length || fetchError) {
    return null
  }

  return (
    <Box
      bg={Color.NeutralGrey_50}
    >
      <Box
        paddingH={6}
        paddingV={5}
        borderBottomWidth={0.5}
        borderColor={Color.NeutralGrey_100}
        borderStyle={BorderStyle.Solid}
      >
        <Heading6>
          Other help categories
        </Heading6>
      </Box>
      {categories && (
        <Box
          paddingH={6}
        >
          <Join
            with={(
              <Box
                borderStyle={BorderStyle.Solid}
                borderColor={Color.ColdGrey_100}
                borderBottomWidth={0.5}
                height="1px"
              />
            )}
          >
            {categories.map((category) => {
              const {
                id, htmlURL, iconName, iconColorLight, name,
              } = category
              const nameSlug = createSlugFromUrl(htmlURL)

              return (
                <OtherTopic
                  id={id}
                  iconName={iconName}
                  iconColour={iconColorLight}
                  name={name}
                  nameSlug={nameSlug}
                  key={id}
                />
              )
            })}
          </Join>
        </Box>
      )}
    </Box>
  )
}

export { OtherHelpTopics }
